import React, { useEffect } from "react";
import { useAuth } from "../../contexts/auth";
import { useNavigate } from "react-router-dom";
import { PartnerDoctorAddForm } from "../../components";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";

export default function PartnerAddDoctorPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user.usertype === "CP" || user.usertype === "DIST") {
    } else {
      navigate("/");
    }
  });

  const breadcrumbItems = [
    { label: "Home", path: "/", active: false },
    {
      label: "Doctor List",
      // path: "/partner-doctor-info",
      path: "/partner-doctor",
      active: false,
    },
    { label: "Create New Doctor", path: "#", active: true },
  ];

  return (
    <React.Fragment>
      <Breadcrumb title="Create New Doctor" items={breadcrumbItems} />
      <div className={"content-block dx-card responsive-paddings"}>
        <PartnerDoctorAddForm />
      </div>
    </React.Fragment>
  );
}
